import { gql } from '@apollo/client';

export const LINK_PHARMACIST_TO_PATIENT = gql`
  mutation assignPatientToSecondaryPharmacist(
    $data: AssignSecondaryPharmacistInput!
  ) {
    assignPatientToSecondaryPharmacist(data: $data) {
      id
    }
  }
`;
